import {
    GET_TEAM_DATA_REQUEST,
    GET_TEAM_DATA_SUCCESS,
    GET_TEAM_DATA_FAIL,
    GET_COST_REPORT_REQUEST,
    GET_COST_REPORT_SUCCESS,
    GET_COST_REPORT_FAIL,
    GET_MONTHLY_REPORT_REQUEST,
    GET_MONTHLY_REPORT_SUCCESS,
    GET_MONTHLY_REPORT_FAIL
} from "./constants"

export const getTeamDataRequest = (payload) => ({
    type: GET_TEAM_DATA_REQUEST,
    payload,
});

export const getTeamDataSuccess = (payload) => ({
    type: GET_TEAM_DATA_SUCCESS,
    payload
});

export const getTeamDataFail = (error) => ({
    type: GET_TEAM_DATA_FAIL,
    error
});

export const getCostReportRequest = (payload) => ({
    type: GET_COST_REPORT_REQUEST,
    payload,
});

export const getCostReportSuccess = (payload) => ({
    type: GET_COST_REPORT_SUCCESS,
    payload
});

export const getCostReportFail = (error) => ({
    type: GET_COST_REPORT_FAIL,
    error
});

export const getMonthlyReportRequest = () => ({
    type: GET_MONTHLY_REPORT_REQUEST,
});

export const getMonthlyReportSuccess = (payload) => ({
    type: GET_MONTHLY_REPORT_SUCCESS,
    payload
});

export const getMonthlyReportFail = (error) => ({
    type: GET_MONTHLY_REPORT_FAIL,
    error
});